import { StyleSheet } from 'react-native';
import { DynamicStyleSheet, variants } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    justifyContent: 'center',
    overflow: 'hidden',
    ...Platform.select({
      ios: {
        borderRadius: theme.radii.ios,
      },
      default: {
        borderRadius: theme.radii.android,
      },
    }),
    ...variants({
      prop: 'size',
      variants: {
        l: {
          height: 44,
          paddingHorizontal: 20,
        },
        m: {
          height: 36,
          paddingHorizontal: 16,
        },
        s: {
          height: 30,
          paddingHorizontal: 16,
        },
      },
    }),
    ...variants({
      primary: {
        backgroundColor: theme.colors.buttonPrimaryBG,
      },
      secondary: {
        backgroundColor: theme.colors.buttonSecondaryBG,
      },
      tertiary: {
        backgroundColor: theme.colors.buttonTertiaryBG,
      },
      outline: {
        borderColor: theme.colors.buttonOutlineBorder,
        borderWidth: StyleSheet.hairlineWidth,
      },
    }),
    ...variants({
      prop: 'fluid',
      variants: {
        false: {
          alignSelf: 'flex-start',
        },
      },
    }),
  },
  side: {
    minWidth: 24,
  },
  before: {
    marginRight: theme.space[2],
    ...variants({
      primary: {
        color: theme.colors.buttonPrimaryText,
      },
      secondary: {
        color: theme.colors.buttonSecondaryText,
      },
      tertiary: {
        color: theme.colors.buttonTertiaryText,
      },
      outline: {
        color: theme.colors.buttonOutlineText,
      },
    }),
  },
  after: {
    marginLeft: theme.space[2],
    alignItems: 'flex-end',
    ...variants({
      primary: {
        color: theme.colors.buttonPrimaryText,
      },
      secondary: {
        color: theme.colors.buttonSecondaryText,
      },
      tertiary: {
        color: theme.colors.buttonTertiaryText,
      },
      outline: {
        color: theme.colors.buttonOutlineText,
      },
    }),
  },
  inner: {
    flexGrow: 1,
    flexShrink: 1,
    textAlign: 'center',
    ...variants([
      {
        primary: {
          color: theme.colors.buttonPrimaryText,
        },
        secondary: {
          color: theme.colors.buttonSecondaryText,
        },
        tertiary: {
          color: theme.colors.buttonTertiaryText,
        },
        outline: {
          color: theme.colors.buttonOutlineText,
        },
      },
      {
        prop: 'size',
        variants: {
          l: {
            fontSize: theme.fontSizes[2],
          },
          m: {
            fontSize: theme.fontSizes[1],
          },
          s: {
            fontSize: theme.fontSizes[0],
          },
        },
      },
    ]),
  },
  content: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  disabled: {
    opacity: 0.4,
  },
}));
